/**
 * Anzeigeregeln der Projektverwaltung (AdminProjectList.tsx), ohne React —
 * damit sie ohne jsdom pruefbar sind.
 */
import type { ProjectStatusSource } from '../../services/projectBilling';

/** Status, wie die Zeile ihn zeigt: allein aus dem Dokument, sonst „Planung". */
export const listenStatus = (projekt: ProjectStatusSource | null | undefined): string =>
    projekt?.data?.metadata?.globalData?.status || 'planning';

export const STATUS_LABEL: Record<string, string> = {
    planning: 'Planung',
    active: 'Ausführung',
    on_hold: 'Ruht',
    completed: 'Beendet',
    // Ein Archivprojekt steht nur dann in der Liste, wenn noch Geld offen ist
    // (Paketgeld zurueckgehalten oder Beleg unbezahlt) — siehe den
    // Archivfilter in der Liste.
    finished: 'Archiv (offen)',
};

/** Reihenfolge der Statusschalter ueber der Tabelle. */
export const STATUS_FILTER: string[] = ['active', 'planning', 'on_hold', 'completed', 'finished'];

/**
 * „Geändert" in der Zeile: heute und gestern mit Uhrzeit, sonst das Datum.
 * Verglichen wird der Kalendertag in Ortszeit, nicht der Abstand in Stunden —
 * 23:50 gestern ist „gestern", auch wenn es erst zehn Minuten her ist.
 */
export const geaendertText = (iso: string | null | undefined, jetzt: Date = new Date()): string => {
    if (!iso) return '–';
    const datum = new Date(iso);
    if (Number.isNaN(datum.getTime())) return '–';
    const tag = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
    const abstand = Math.round((tag(jetzt) - tag(datum)) / 86_400_000);
    const uhrzeit = datum.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
    if (abstand === 0) return `heute, ${uhrzeit}`;
    if (abstand === 1) return `gestern, ${uhrzeit}`;
    return datum.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

/** Zwei Buchstaben fuer den Kreis vor dem Namen; ohne Namen ein Fragezeichen. */
export const initialen = (vorname?: string | null, nachname?: string | null): string => {
    const zeichen = `${(vorname || '').trim().charAt(0)}${(nachname || '').trim().charAt(0)}`.toUpperCase();
    return zeichen || '?';
};
